// client/src/components/chat/RoomPanel.js
import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import ChatMessageItem from './ChatMessageItem';
import MessageInput from './MessageInput';
import RoomUserList from './RoomUserList';

export default function RoomPanel({
  room, messages, typingUsers, onlineUsers,
  currentUserId, currentUsername,
  onSendMessage, onTypingStart, onTypingStop, onSetStatus, onJoinRoom,
}) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const typingList = Object.values(typingUsers || {})
    .filter(username => username !== currentUsername);

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', bgcolor: 'background.default' }}>
      <Box sx={{
        px: 2, py: 1.25,
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        bgcolor: 'rgba(0,0,0,0.15)',
        display: 'flex', alignItems: 'center', gap: 1,
      }}>
        <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 700 }}>
          #{room.name}
        </Typography>
        {room.topic && (
          <Typography variant="caption" sx={{ color: 'text.disabled', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            — {room.topic}
          </Typography>
        )}
      </Box>

      <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        <Box sx={{ flex: 1, overflowY: 'auto', py: 1, display: 'flex', flexDirection: 'column' }}>
          {messages.length === 0 && (
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                No messages yet. Be the first!
              </Typography>
            </Box>
          )}
          {messages.map((msg, i) => (
            <ChatMessageItem
              key={msg._id || i}
              message={msg}
              isOwn={String(msg.userId?._id || msg.userId) === String(currentUserId)}
            />
          ))}
          {typingList.length > 0 && (
            <Box sx={{ px: 1.5, py: 0.5 }}>
              <Typography variant="caption" sx={{ color: 'text.disabled', fontStyle: 'italic' }} className="retro-typing">
                {typingList.join(', ')} {typingList.length === 1 ? 'is' : 'are'} typing…
              </Typography>
            </Box>
          )}
          <div ref={bottomRef} />
        </Box>

        <RoomUserList onlineUsers={onlineUsers} currentUserId={currentUserId} />
      </Box>

      <MessageInput
        activeRoom={room.name}
        onSendMessage={onSendMessage}
        onTypingStart={onTypingStart}
        onTypingStop={onTypingStop}
        onSetStatus={onSetStatus}
        onJoinRoom={onJoinRoom}
      />
    </Box>
  );
}
